import styled from 'styled-components'

export const Image = styled.div.attrs({ className: 'icon is-small' })`
  padding-left: 7px;
`
